$(function() {

  checkScrolled();
  fadeAnimation();

  $(window).on('scroll', function() {
    checkScrolled();
    fadeAnimation();

    // 購買品紹介ページの左メニューの存在チェック
    if($('.p-purchases__category-links').length) {
      let target = $(window).scrollTop() + 84;
      if(target >= $('.p-purchases__category-links').offset().top) {
        if(!$('.p-purchases__category-links').hasClass('p-purchases__category-links--reached')) {
          $('.p-purchases__category-links').addClass('p-purchases__category-links--reached');
        }
      } else {
        $('.p-purchases__category-links').removeClass('p-purchases__category-links--reached');
      }
    }
  });

  function fadeAnimation() {
    $('.fadeUpAnimation').each(function() {
      const elementPosition = $(this).offset().top + 100;
      const scroll = $(window).scrollTop();
      const winHeight = $(window).height();
      if(scroll >= elementPosition - winHeight) {
        $(this).addClass('fadeUp');
      } else {
        // $(this).removeClass('fadeUp');
      }
    });

  }

  const headerHight = 84;
  $("a[href^='#']").on('click', function() {
    const speed = 1000;
    const href = $(this).attr('href');
    const target = $(href == "#" || href == "" ? 'html' : href);
    const position = target.offset().top - headerHight;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });


  $('.p-hamburger').on('click', function(e) {
    var scroll = $(window).scrollTop();

    if($(this).hasClass('active')) {
      $(this).removeClass('active');
      if(scroll <= 10 && $('.p-header').hasClass('p-header--scrolled')) {
        $('.p-header').removeClass('p-header--scrolled');
        $('.l-header').removeClass('l-header--scrolled');
      }
    } else {
      $(this).addClass('active');
      if(scroll <= 10 && !$('.p-header').hasClass('p-header--scrolled')) {
        $('.p-header').addClass('p-header--scrolled');
        $('.l-header').addClass('l-header--scrolled');
      }
    }
    $('.p-sp-menu').toggle();
  });

  $('.p-sp-menu__switch').on('click', function() {
    if($(this).hasClass('p-sp-menu__switch--opened')) {
      $(this).removeClass('p-sp-menu__switch--opened');
    } else {
      $(this).addClass('p-sp-menu__switch--opened');
    }
    $(this).next().toggle();
  });

  $('.p-faq-list__question').on('click', function() {
    if($(this).parent().hasClass('p-faq-list__item--opened')) {
      $(this).parent().removeClass('p-faq-list__item--opened');
    } else {
      $(this).parent().addClass('p-faq-list__item--opened');
    }

  });

  function checkScrolled() {
    var scroll = $(window).scrollTop();
    if(scroll > 10) {
      $('.p-header').addClass('p-header--scrolled');
      $('.l-header').addClass('l-header--scrolled');
    } else {
      // スクロールが10以下でもメニューがアクティブの場合はクラスを削除しない
      if(!$('.p-hamburger').hasClass('active')) {
        $('.p-header').removeClass('p-header--scrolled');
        $('.l-header').removeClass('l-header--scrolled');
      }
    }
  }

});
